export default __webpack_public_path__ + "static/media/logo.49c01135.png";